// extracted by mini-css-extract-plugin
module.exports = {"whyQuattron":"whyQuattron_whyQuattron__vqtLU","whyContainer":"whyQuattron_whyContainer___4_FR","whyItem":"whyQuattron_whyItem__waCVL"};